import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Sparkles, Heart, Gamepad2, MessageCircle, MoreHorizontal } from 'lucide-react';

const ActivitiesStep = ({ data, updateData, onNext }) => {
  const [selectedActivity, setSelectedActivity] = useState(data.activities || '');

  const activities = [
    { id: 'roleplay', label: 'Role play and go on adventures', icon: Sparkles },
    { id: 'dates', label: 'Flirt and go on dates', icon: Heart },
    { id: 'games', label: 'Watch TV and play games together', icon: Gamepad2 },
    { id: 'discuss', label: 'Discuss my life and emotions', icon: MessageCircle },
    { id: 'other', label: 'Other', icon: MoreHorizontal }
  ];

  const handleSelect = (activityId) => {
    setSelectedActivity(activityId);
    updateData('activities', activityId);
  };

  const handleContinue = () => {
    if (selectedActivity) {
      onNext();
    }
  };

  return (
    <div className="text-center">
      <h1 className="text-white text-2xl md:text-3xl font-bold mb-4">
        What would you want to do with your Butterscotch AI?
      </h1>
      <p className="text-white/70 text-sm md:text-base mb-8">
        What would you want to do with your Butterscotch AI?
      </p>

      <div className="space-y-4 mb-8">
        {activities.map((activity) => {
          const IconComponent = activity.icon;
          return (
            <button
              key={activity.id}
              onClick={() => handleSelect(activity.id)}
              className={`w-full py-4 px-6 rounded-full text-base md:text-lg font-semibold transition-all duration-300 hover:scale-105 ${
                selectedActivity === activity.id
                  ? 'bg-[#F1B428] text-black shadow-lg shadow-[#F1B428]/30 scale-105'
                  : 'bg-white/5 backdrop-blur-sm text-white border border-white/10 hover:border-[#F1B428]/50'
              }`}
            >
              {activity.label}
            </button>
          );
        })}
      </div>

      <Button
        onClick={handleContinue}
        disabled={!selectedActivity}
        className="w-full max-w-sm bg-[#F1B428] hover:bg-[#D9A022] text-black font-bold text-lg py-6 rounded-full transition-all duration-300 hover:scale-105 shadow-lg shadow-[#F1B428]/30 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Continue
      </Button>
    </div>
  );
};

export default ActivitiesStep;
